export class ShovalEnrollmentVolume {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudVolumeId",
            "baseName": "cloudVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestedAt",
            "baseName": "requestedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "attachedAt",
            "baseName": "attachedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "rejectReason",
            "baseName": "rejectReason",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ShovalEnrollmentVolume.attributeTypeMap;
    }
    constructor() {
    }
}
